import * as ng from 'angular';
import * as ASM from './../../../data/interfaces';
import * as Core from './../../../core';

interface IAccountRequestResource extends ng.resource.IResourceClass<ASM.IAccountRequest> {
    insert(params: any, accountRequest: ASM.IAccountRequest): ASM.IAccountRequest; //TODO: verify interfaces
    validate(profile: ASM.IAccountRequest): ASM.IAccountRequest;
}

let AccountRequestResourceFactory: Function = function ($resource: ng.resource.IResourceService,
    exception: Core.IException, logger: Core.ILogger, SiteConfig: Core.ISiteConfigService): IAccountRequestResource {

        return <IAccountRequestResource>$resource(
            SiteConfig.getResourceUri("accountRequest"),
            { id: '@id' } as any,
            new AccountRequestResource(SiteConfig) as any
        );
    };

AccountRequestResourceFactory.$inject = ['$resource', 'exception', 'logger', 'SiteConfig'];

class AccountRequestResource {

    constructor(private SiteConfig: Core.ISiteConfigService) {

    }

    public query: ng.resource.IActionDescriptor = {
        method: 'POST',
        isArray: true,
        params: {
            query: true
        }
    };

    public insert: ng.resource.IActionDescriptor = {
        url: this.SiteConfig.getResourceUri("newAccountRequest"),
        method: 'POST',
    };

    public validate: ng.resource.IActionDescriptor = {
        url: this.SiteConfig.getResourceUri("newAccountRequest"),
        method: 'POST',
        isArray: true,
        params: {
            validate: true
        }
    };

}

let AccountRequest = {
    name: "AccountRequest",
    factory: AccountRequestResourceFactory
};

export { AccountRequest, IAccountRequestResource }
export default AccountRequest;

//TODO: import into an index file -  .module('app.public')


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/public/data/account-request.ts